module.exports = __webpack_public_path__ + "static/media/Pile.e188b28e.jpg";